import { useSearchParams } from 'react-router-dom';

import { Path, useNavigate, useParams } from '@/router';

export function getDriveToStoreReportUrl(
  entityType: string,
  entityId: string,
  opts?: { venueIds?: string[]; poiId?: string; lineItemIds?: string[] }
): Path {
  const base = `/reporting/driveToStore/${entityType}/${entityId}`;
  const params = new URLSearchParams();
  if (opts?.poiId) {
    params.set('poiId', opts.poiId);
  }
  if (opts?.venueIds?.length) {
    params.set('venueIds', opts.venueIds.join(','));
  }
  if (opts?.lineItemIds?.length) {
    params.set('lineItemIds', opts.lineItemIds.join(','));
  }
  const query = params.toString();
  return (query ? `${base}?${query}` : base) as Path;
}

export function useDriveToStoreNavigation() {
  const { entityType, entityId } = useParams('/reporting/driveToStore/:entityType/:entityId');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const country = searchParams.get('country') ?? undefined;
  const activePoiId = searchParams.get('poiId') ?? undefined;
  const venueIdsParam = searchParams.get('venueIds');
  const activeVenueIds = venueIdsParam ? venueIdsParam.split(',').filter(Boolean) : undefined;
  const lineItemIdsParam = searchParams.get('lineItemIds');
  const activeEntityIds = lineItemIdsParam ? lineItemIdsParam.split(',').filter(Boolean) : undefined;
  const entityIds = entityId ? entityId.split(',').filter(Boolean) : [];
  const navigateToReport = (opts?: {
    newTab?: boolean;
    poiId?: string;
    venueIds?: string[];
    lineItemIds?: string[];
  }) => {
    const url = getDriveToStoreReportUrl(entityType, entityId, opts);
    if (opts?.newTab) {
      window.open(url, '_blank', 'noopener,noreferrer');
      return;
    }
    navigate(url);
  };

  return {
    activeEntityIds,
    activePoiId,
    activeVenueIds,
    country,
    entityId,
    entityIds,
    entityType,
    navigateToReport
  };
}
